"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeItemContent = exports.TreeItemChildren = exports.TreeItem = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_collapsed_1 = (0, tslib_1.__importDefault)(require("react-collapsed"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var tree_view_context_1 = require("../tree-view/tree-view-context");
var tree_item_children_1 = require("./components/tree-item-children");
Object.defineProperty(exports, "TreeItemChildren", { enumerable: true, get: function () { return tree_item_children_1.TreeItemChildren; } });
var tree_item_content_1 = require("./components/tree-item-content");
Object.defineProperty(exports, "TreeItemContent", { enumerable: true, get: function () { return tree_item_content_1.TreeItemContent; } });
var animationStyles = {
    transitionDuration: '.2s',
};
function TreeItem(_a) {
    var children = _a.children;
    var _b = (0, tree_view_context_1.useTreeView)(), itemsGap = _b.itemsGap, expanded = _b.expanded;
    var _c = (0, react_1.useState)(expanded), isExpanded = _c[0], setIsExpanded = _c[1];
    var childrenNodes = Array.isArray(children) ? children : [children];
    var itemContentNode = childrenNodes[0];
    var itemChildrenNode = childrenNodes[1];
    var isLeaf = childrenNodes.length === 1 && childrenNodes[0].type !== tree_item_children_1.TreeItemChildren;
    var _d = (0, react_collapsed_1.default)({
        isExpanded: isExpanded,
        expandStyles: animationStyles,
        collapseStyles: animationStyles,
    }), getCollapseProps = _d.getCollapseProps, getToggleProps = _d.getToggleProps;
    var itemContentProps = {
        getToggleProps: getToggleProps({
            onClick: function () {
                setIsExpanded(function (oldExpanded) { return !oldExpanded; });
            },
        }),
        isExpanded: isExpanded,
        isLeaf: isLeaf,
    };
    var itemChildrenProps = { getCollapseProps: getCollapseProps, isLeaf: isLeaf };
    return (react_1.default.createElement(StyledTreeItem, { role: "treeitem", gap: itemsGap },
        react_1.default.cloneElement(itemContentNode, itemContentProps),
        itemChildrenNode ? react_1.default.cloneElement(itemChildrenNode, itemChildrenProps) : null));
}
exports.TreeItem = TreeItem;
var StyledTreeItem = styled_components_1.default.li(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n\n  &:not(:last-child) {\n    padding-bottom: ", "px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n\n  &:not(:last-child) {\n    padding-bottom: ", "px;\n  }\n"])), function (_a) {
    var gap = _a.gap;
    return gap;
}, function (_a) {
    var gap = _a.gap;
    return gap;
});
var templateObject_1;
//# sourceMappingURL=index.js.map